// Auth utility functions
import { getLegacyToken } from '../../config/etaxToken';
export const logout = () => {
    console.log('🔒 Logging out user');
    localStorage.clear();
    window.location.href = '/';
};

export const isAuthenticated = (): boolean => {
    const token = getLegacyToken();
    return !!token;
};

export const getToken = (): string | null => {
    return getLegacyToken();
};

export const getAccountantOid = (): string | null => {
    return localStorage.getItem('accountantOid');
};

export const getUserRole = (): string | null => {
    return localStorage.getItem('userRole');
}; 